"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }/* Save as template's blanks, for the web modal and the mobile sheet. The
 * message is sent to SuggestTemplateBlanks once on open, and again after the
 * user edits the text and pauses, so the notice and highlights follow the
 * text. Turning a blank on or off rewrites the body from the text the blanks
 * index; typing ends that, and the next detection starts over from what was
 * typed (with nothing on). */
var _react = require('react');




var _messageTemplate = require('shared/actions/messageTemplate'); var _messageTemplate2 = _interopRequireDefault(_messageTemplate);



var _templateFromMessage = require('shared/services/templateFromMessage');

// How long typing pauses before the edited text is checked again.
 const REDETECT_MS = 700; exports.REDETECT_MS = REDETECT_MS





































 const useTemplateBlanks = ({ orgKey, conversationKey, text, staffName, onlyOnePatient }) => {
  const [state, setState] = _react.useState(() => {
    const blanks = _templateFromMessage.staffNameBlanks.call(void 0, text, staffName)
    return { base: text, blanks, on: blanks.map(() => true) }
  })
  // Typed text, until the next detection catches up with it.
  const [typed, setTyped] = _react.useState(null)
  const [reviewing, setReviewing] = _react.useState.call(void 0, false)
  // The text to check next; `initial` only for the message as opened.
  const [request, setRequest] = _react.useState.call(void 0, { text, initial: true })
  const [failed, setFailed] = _react.useState.call(void 0, false)

  _react.useEffect.call(void 0, () => {
    let current = true
    const timer = setTimeout(() => {
      _messageTemplate2.default.suggestTemplateBlanks(orgKey, conversationKey, request.text)
        .then(({ Blanks }) => {
          if (!current) return
          const blanks = _templateFromMessage.mergeBlanks.call(void 0, _nullishCoalesce(Blanks, () => ( [])), _templateFromMessage.staffNameBlanks.call(void 0, request.text, staffName))
          const defaults = request.initial ? _templateFromMessage.defaultBlanksOn.call(void 0, blanks, onlyOnePatient) : blanks.map(() => false)
          // Choices made while the first check ran (unchecking the sender's
          // name, say) stay. Typing ends them: a check of typed text starts
          // with nothing on, so a value typed back in by hand stays as typed.
          setState(previous => ({
            base: request.text,
            blanks,
            on: request.initial ? _templateFromMessage.carryBlanksOn.call(void 0, previous, request.text, blanks, defaults) : defaults,
          }))
          setTyped(t => t === request.text ? null : t)
          setFailed(false)
        })
        .catch((e) => {
          // Offline or refused: nothing is lost, and the notice says so.
          log.info('Couldn\'t check the message for patient details', e)
          if (current) setFailed(true)
        })
    }, request.initial ? 0 : exports.REDETECT_MS)
    return () => { current = false; clearTimeout(timer) }
  }, [request, orgKey, conversationKey, staffName, onlyOnePatient])

  const built = _react.useMemo.call(void 0, () => _templateFromMessage.applyBlanks.call(void 0, state.base, state.blanks, state.on), [state])
  const setBody = _react.useCallback.call(void 0, (next) => {
    setTyped(next)
    setRequest({ text: next, initial: false })
    setReviewing(false)
    // A new check is coming; an earlier failure no longer applies.
    setFailed(false)
  }, [])
  const blankAll = _react.useCallback.call(void 0, () => {
    setState(s => ({ ...s, on: _templateFromMessage.blankAllOn.call(void 0, s.blanks, s.on) }))
    setReviewing(false)
  }, [])
  const review = _react.useCallback.call(void 0, () => {
    setState(s => ({ ...s, on: _templateFromMessage.blankAllOn.call(void 0, s.blanks, s.on) }))
    setReviewing(true)
  }, [])
  const closeReview = _react.useCallback.call(void 0, () => setReviewing(false), [])
  const retry = _react.useCallback.call(void 0, () => {
    setFailed(false)
    setRequest(r => ({ ...r }))
  }, [])
  const toggle = _react.useCallback.call(void 0, (index) => {
    setState(s => ({ ...s, on: s.on.map((value, i) => i === index ? !value : value) }))
  }, [])

  const editing = typed !== null
  return {
    body: editing ? typed : built.body,
    setBody,
    blanks: editing ? [] : state.blanks,
    on: editing ? [] : state.on,
    marks: editing ? [] : built.marks,
    // A failed check shows (with Retry) even while the text is typed; stale
    // highlights don't.
    notice: failed ? _templateFromMessage.BLANK_CHECK_FAILED : editing ? null : _templateFromMessage.blankNotice.call(void 0, state.blanks, state.on),
    reviewing: !editing && reviewing,
    blankAll,
    review,
    closeReview,
    toggle,
    retry,
  }
}; exports.useTemplateBlanks = useTemplateBlanks
